export const RADAR_INTRO_PATH = 'intro';
export const RADAR_EDIT_PATH = 'edit';
export const RADAR_BANNED_PATH = 'banned';
export const RADAR_CONNECTIONS_PATH = 'connections';
export const RADAR_PREVIEW_PATH = 'preview';

export const RADAR_TERMS_PATH = '/radarTerms';
export const RADAR_PRIVACY_PATH = '/radarPrivacy';
export const RADAR_MAIN_PATH = ' ';
